<template>
    <div>
        <div class="table-holder">
            <table class="table">
                <thead class="thead-dark">
                    <tr>
                        <th class="text-center">No</th>
                        <th class="text-center">Author Email</th>
                        <th class="text-center">Referral link</th>
                        <th class="text-center">Joined People emails</th>
                        <th class="text-center">Joined People</th>
                    </tr>
                </thead>
                <tbody>
                    <TableRow
                        v-for="referral in referrals" 
                        :key="`referral-${referral.id}`"
                        :referral="referral"/>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { db, ADMINS } from '../../../firebase'
import TableRow from './TableRow'

export default {
    name: 'RefsPanel',
    components: {
        TableRow,
    },
    data() {
        return {
            referrals: [],
            users: [],
            emails: {},
            email: 'All',
            userId: null,
        }
    },
    computed: {
        ...mapState([
            'user'
        ]),
    },
    mounted: function() {
        if(ADMINS.includes(this.user.uid)) {
            this.getReferrals()
            return
        }
        return this.$router.push('/').catch(()=>{})

    },
    methods: {
        getReferrals: function() {
            db
                .collection('referrals')
                .get()
                .then(referral => {
                    this.referrals = referral.docs.map(
                        (doc, index) => {
                            const data = doc.data()
                            return {
                                ...data,
                                index,
                                refLink: `${window.location.host}?refId=${data.authorId}`,
                                id: doc.id
                            }
                        }
                    )
                })
        },
    }

}
</script>
 
<style scoped>
table {
    width: 100%;
}
th {
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
}
td {
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
}
</style>